import React from 'react';
import "./c90_contact_form.scss";
import { PageLeftItem } from "../../model/page";
import TemplateComponent, { TemplateComponentProps } from "../../containers/template_page/template_component/template_component";
import { countries } from '../../utils/countries';
import { TFunction } from "i18next";
import { Formik, Field, Form } from 'formik';
import { Button } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { API_CONFIG } from "../../config/api_config";
import { Link } from "react-router-dom";
import axios from "axios";



export interface C90ContactFormData extends PageLeftItem {
    title: string;
    content: string;
}

const initValuesCF = {
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    paese: '',
    codice: '',
    webform_id: 'contatti_corsi',
    lingua: '',
    data_richiesta: '',
    consenso: true,
    contatto: true,
    organico: true,
    utm_campaign: '',
    utm_source: '',
    utm_medium: '',
    gclid: '',
    dclid: ''
}

declare global {
    interface Window {
        dataLayer: any;
    }
}


const contactFormURI = `${API_CONFIG.PROD + API_CONFIG.CONTACT_FORM}`;

const TIME = 5000;
let message: string = '';

class C90ContactForm extends TemplateComponent<C90ContactFormData> {

    static readonly ID: string = "contact_form";

    //we retrieve the query params for UTM logic
    queryParams = new URLSearchParams(window.location.search);
    utm_campaign = this.queryParams.get("utm_campaign");
    utm_source = this.queryParams.get("utm_source");
    utm_medium = this.queryParams.get("utm_medium");
    gclid = this.queryParams.get("gclid");
    dclid = this.queryParams.get("dclid");



    state: {
        opened: boolean,
        overlay: boolean,
        message: boolean,
        loader: boolean,
        btn: boolean,
        class: string
    };

    title: any;
    lang: any;
    label: any;

    constructor(props: TemplateComponentProps<C90ContactFormData>) {
        super(props);

        if (props.course) {
            localStorage.setItem('coursetitle', props.course);
        }

        if (props.language) {
            localStorage.setItem('lang', props.language);
        }

        this.state = {
            opened: false,
            overlay: false,
            loader: false,
            message: false,
            btn: false,
            class: '',
        }

        this.requireInternationalization = true;
    }



    pushDataLayer() {
        window.dataLayer.push({
            'event': 'submit_form',
            'formType': 'contactForm',
            'course': '$course-name'
        });

        console.log("DataLayer: " + window.dataLayer);
    }

    openForm() {
        this.setState({
            opened: !this.state.opened
        })
    }

    twoDigits(num: any) {
        return num.toString().padStart(2, '0');
    }

    formatDate(date: any) {
        return [
            this.twoDigits(date.getDate()),
            this.twoDigits(date.getMonth() + 1),
            date.getFullYear(),
        ].join('/');
    }

    validateEmail(value: string, t: any) {
        let error;
        if (!value) {
            error = t['required'];
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            error = t['invalidMailAddress'];
        }
        return error;
    }

    validateFiled(value: string, t: any) {
        let error;
        if (!value) {
            error = t['required'];
        } else if (!/^[-'0-9a-zA-ZÀ-ÿ\s]*$/.test(value)) {
            return t['invalidChar'];
        }
        return error;
    }

    validatePhone(value: string, t: any) {
        if (!value) {
            return '';
        } else if (value && !/^[\d\s]+$/.test(value)) {
            return t['invalidDigit'];
        } else if (!/^.{7,}$/.test(value)) {
            return t['minLength'];
        }
    }

    validateSelect(value: string, t: any) {
        let error;
        if (!value) {
            error = t['required'];
        }
        return error;
    }

    validateConsent(value: string, t: any) {
        let error;
        if (!value || value.length <= 0) {
            error = t['required'];
        }
        return error;
    }

    setLabel(name: any) { this.label = name; }

    internationalComponentRender(data: C90ContactFormData, t: TFunction): React.ReactElement<any> {

        this.title = localStorage.coursetitle;
        this.lang = localStorage.lang;

        const textTranslation = {
            required: t("C90 Required"),
            invalidMailAddress: t("C90 Invalid Mail Address"),
            invalidDigit: t("C90 Invalid Digit"),
            invalidChar: t("C90 Invalid Char"),
            minLength: t("C90 Min Length"),
        }

        return (
            <div className={`c90_contact_form ${this.state.opened ? "opened" : ""}`}>
                <div className="popup-button-container" onClick={() => this.openForm()}>
                    <div id="cta_getInTouch" className="popup-button" />
                    <h3 className="title">{t("C90 Contact Us")}</h3>
                </div>
                <div className="html-popup">
                    <div className={`popup-loader ${this.state.overlay ? "active" : ""}`}>
                        <div className={`container ${this.state.loader ? "active" : ""}`}>
                            <div className="load-container">
                                <div className="linespinner"></div>
                            </div>
                        </div>
                        <div className={`output-message ${this.state.message ? "active" : ""}`}>
                            <p className={this.state.class}>{message}</p>
                        </div>
                    </div>
                    <h3 className="popup-title"></h3>
                    <div className="popup-content editor-html">
                        <b>{t("C90 Ask") + ` ` + this.title.trim() + t("C90 Course") + `?`}</b>
                        <p>{t("C90 Description")}</p>
                        <Formik
                            initialValues={
                                initValuesCF
                            }
                            onSubmit={(values: any, actions) => {
                                this.pushDataLayer();

                                this.setState({ btn: true, overlay: true, loader: true });

                                //UTM Logic
                                if ((this.utm_campaign != null && this.utm_campaign !== '') || (this.utm_source != null && this.utm_source !== '') || (this.utm_medium != null && this.utm_medium !== '') || (this.gclid != null && this.gclid !== '') || (this.dclid != null && this.dclid !== '')) {
                                    values.organico = false;
                                }
                                values.utm_campaign = this.utm_campaign != null ? this.utm_campaign : '';
                                values.utm_source = this.utm_source != null ? this.utm_source : '';
                                values.utm_medium = this.utm_medium != null ? this.utm_medium : '';
                                values.gclid = this.gclid != null ? this.gclid : '';
                                values.dclid = this.dclid != null ? this.dclid : '';

                                // same shape as initial values
                                Object.keys(values).forEach((e: any) => {
                                    values.corso = this.title.trim();
                                    values.lingua = this.lang;
                                    values.paese = this.label;
                                    values.data_richiesta = this.formatDate(new Date());
                                    if (typeof values[e] !== 'boolean') { values[e] = values[e].trim(); }

                                });

                                axios.post(contactFormURI, values)
                                    .then((res) => {
                                        if (res.data.sid) {
                                            message = t("C90 Success");
                                            this.setState({ loader: false, message: true, class: 'success' });
                                            setTimeout(() => {
                                                this.setState({ btn: false, overlay: false, message: false });
                                                actions.resetForm({
                                                    values: initValuesCF,
                                                });
                                            }, TIME);
                                        }
                                    }).catch((error) => {
                                        message = t("C90 Error");
                                        this.setState({ loader: false, message: true, class: 'error' });
                                        setTimeout(() => {
                                            this.setState({ btn: false, overlay: false, message: false });
                                        }, TIME);
                                        console.log('### Failed to send data: ' + error);
                                    });


                            }}
                            enableReinitialize
                        >
                            {({ errors, touched }) => (
                                <Form className="contact_form">
                                    <div className='field_form'>
                                        <Field name="nome" placeholder={t("C90 Name")} validate={(value: any) => this.validateFiled(value, textTranslation)} />
                                        {errors.nome && touched.nome && <div className="invalid">{errors.nome}</div>}
                                    </div>
                                    <div className='field_form'>
                                        <Field name="cognome" placeholder={t("C90 Surname")} validate={(value: any) => this.validateFiled(value, textTranslation)} />
                                        {errors.cognome && touched.cognome && <div className="invalid">{errors.cognome}</div>}
                                    </div>
                                    <div className='field_form'>
                                        <Field name="email" placeholder={t("C77 Email")} validate={(value: any) => this.validateEmail(value, textTranslation)} />
                                        {errors.email && touched.email && <div className="invalid">{errors.email}</div>}
                                    </div>
                                    <div className='field_form'>
                                        <Field name="telefono" placeholder={t("C77 Phone")} validate={(value: any) => this.validatePhone(value, textTranslation)} />
                                        {errors.telefono && touched.telefono && <div className="invalid">{errors.telefono}</div>}
                                    </div>
                                    <div className='field_form'>
                                        <Field
                                            name="codice"
                                            as="select"
                                            title="sel_Country"
                                            validate={(value: any) => this.validateSelect(value, textTranslation)}
                                            onBlur={(e: any) => this.setLabel(e.target[e.target.selectedIndex].text)}
                                        >
                                            <option key={'default'} value="">{t("C90 Select Country Study")}</option>
                                            {countries.map((e: any, i: number) =>
                                                <option key={'country_' + i} value={e.code}>{e.name}</option>
                                            )}
                                        </Field>
                                        {errors.codice && touched.codice && <div className="invalid">{errors.codice}</div>}
                                    </div>
                                    <div className='field_form checkbox'>
                                        <FormLabel className='policy'>
                                            <Field type="checkbox" name="consenso" validate={(value: any) => this.validateConsent(value, textTranslation)} />
                                            <p className="privacy">{t("C90 Consent")} <Link to={(this.lang === 'it') ? '/informativa-sulla-privacy' : '/privacy-policy'} className="link_privacy"> {t("C90 Privacy")} </Link></p>
                                        </FormLabel>
                                        {errors.consenso && touched.consenso && <div className="invalid">{errors.consenso}</div>}
                                    </div>
                                    <div className='field_form checkbox'>
                                        <FormLabel>
                                            <Field type="checkbox" name="contatto" validate={(value: any) => this.validateConsent(value, textTranslation)} />
                                            {t("C90 Contact")}
                                        </FormLabel>
                                        {errors.contatto && touched.contatto && <div className="invalid">{errors.contatto}</div>}
                                    </div>
                                    <div className='container-btn'>
                                        <Button disabled={this.state.btn} type="submit" className='btn-submit'>{t("C90 Submit")}</Button>
                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }
}

export default C90ContactForm;
